<template>
    <div class="content-header">
        <div class="content-header-text">{{ text }}</div>
        <div class="content-header-upper-text">{{ upperText }}</div>
        <div class><svg-icon @click="svgClick" :svgData="svgData"/></div>
    </div>
</template>
<script>



import SvgIcon from '@/components/content/SvgIcon.vue'

export default {
    
    name: 'ContentHeader',
    components: {
        SvgIcon
    },
    props: {
        text: String,
        upperText: String,
        svgData: Object
    },
    methods: {
        svgClick(){
            this.$emit('svgClick')
        }
    }
    
}
</script>